import React from "react";
import { Typography } from "@mui/material";
import { GaDialogShell, GaLimeCta } from "../../../components/ui/GaDialogs";
import { ga } from "../../../components/ui/GaPrimitives";

export function MythFactNoticeDialog({
  open,
  message,
  cta = "GOT IT",
  onClose,
}) {
  return (
    <GaDialogShell open={open} onClose={onClose} width={340} desktopWidth={420}>
      <Typography
        sx={{
          fontFamily: "'Rajdhani', sans-serif",
          fontWeight: 700,
          fontSize: 18,
          letterSpacing: "1.2px",
          color: ga.lime,
          mb: 1.5,
        }}
      >
        MYTH OR FACT
      </Typography>
      <Typography
        sx={{
          fontFamily: "'Poppins', sans-serif",
          fontWeight: 500,
          fontSize: 14,
          lineHeight: "22px",
          color: "#F2FAE6",
          mb: 3,
          maxWidth: 280,
        }}
      >
        {message}
      </Typography>
      <GaLimeCta onClick={onClose}>{cta}</GaLimeCta>
    </GaDialogShell>
  );
}
